import helper from "./helper"

const getMendeleevUrlWithParameters = helper.getMendeleevUrlWithParameters

export default {
  CHOICES: {
    EDUCATION_LEVEL:
      (gets = null) => getMendeleevUrlWithParameters(
        'choices|members|education',
        'get',
        {},
        gets
      ),
    ACADEMIC_DEGREE:
      (gets = null) => getMendeleevUrlWithParameters(
        'choices|members|academic|degree',
        'get',
        {},
        gets
      ),
    MEMBERS_POSITION:
      (gets = null) => getMendeleevUrlWithParameters(
        'choices|members|positions',
        'get',
        {},
        gets
      ),
  },
}
